import { createAction } from '@reduxjs/toolkit';

export type LayoutStyle = 'default' | 'compact';
export const changeLayoutStyle = createAction<LayoutStyle>(
  'uiPreferences/changeLayoutStyle',
);

export type TextSize = 'smallest' | 'small' | 'medium' | 'large' | 'largest';
export const changeTextSize = createAction<TextSize>(
  'uiPreferences/changeTextSize',
);
